import { createBrowserRouter } from 'react-router-dom';
import { publicRoutes } from './publicRoutes';
import { protectedRoutes } from './protectedRoutes';

/**
 * Application router combining public and protected route trees.
 * All page components are lazy-loaded via React.lazy() + Suspense.
 */
export const router = createBrowserRouter([
  ...publicRoutes,
  ...protectedRoutes,
]);
